import {AxiosInstance} from "axios";
import LegacyAccess from "@/core/interfaces/Access";

/**
 * The environment resource.
 * @author Tony Laurent <t.laurent@apodispharma.com>
 * @param {Object} client - The injected client.
 */
export default function (client: AxiosInstance) {
    return {
        /**
         * Read the environment.
         * @returns {Promise} Promise object represents the HTTP request.
         */
        async read(withIncludes: boolean = true): Promise<LegacyAccess> {
            const includes = [
                'user',
                'entity.grouping.branding',
                'entity.sponsorshipSponsors.videos',
                'entity.sponsorshipSponsors.extensions',
                'entity.sponsorshipSponsors.entity.branding.logo',
            ];

            const params = withIncludes ? {include: includes.join(',')} : {};


            return await client
                .get('/profile/accesses/current', {
                    params
                })
                .then(response => response.data.access)
                .catch(() => null);
        }
    };
}
